import React, { Component as C } from "react"
import classNames from "classnames"

import BaseHeaderRow from "../base-header-row/index.jsx"

import styles from "../../common-styles/styles.less"

export default class extends C {
  static displayName = "TableHeaderRow"

  handleCheckboxChange(e, checked) {
    this.props.onSelect(checked)
  }

  render() {
    return (
      <BaseHeaderRow
        {...this.props}
        className={classNames(styles.additionalHr, this.props.className)}
        ignoreSizeCalculation={true}>
        {this.props.children}
      </BaseHeaderRow>
    )
  }
}
